import type { IconData } from '@stacksjs/iconify-core'

export const drumStickRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M32.03 1.01c3.758.143 7.264 1.96 10.132 4.827s4.684 6.375 4.828 10.133c.145 3.777-1.405 7.657-4.983 11.235c-3.555 3.555-8.508 6.21-13.298 7.279c-2.552.569-5.137.7-7.461.223l-3.983 3.414a6 6 0 1 1-11.193 3.808a6.001 6.001 0 1 1 3.806-11.194l3.414-3.983c-.477-2.325-.346-4.91.223-7.461c1.068-4.791 3.724-9.744 7.28-13.3C24.372 2.415 28.252.866 32.029 1.01M15.034 30.863l-3.385 3.95a2 2 0 0 1-3.083-.057a2 2 0 1 0-.978 3.156a2 2 0 0 1 2.498 2.499a2 2 0 1 0 3.155-.979a2 2 0 0 1-.057-3.084l3.95-3.385a9.2 9.2 0 0 1-2.1-2.1m19.952-4.735a1.5 1.5 0 0 0-1.976-2.258C30.811 25.796 27.673 27 24 27a1.5 1.5 0 0 0 0 3c4.326 0 8.188-1.421 10.988-3.871\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default drumStickRemix
